import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";
import Helper from "util/Helper";

export class AssignUtils {
  constructor() {
    this.apiService = new APIService();
    this.helper = new Helper();
  }
  saveAccount(body, onResponse, onError) {
    let url = APIConfig.myPlan.accountDashboard.create;
    return this.apiService.post(url, body, onResponse, onError);
  }
  //---
  fetchPatientId(id, onResponse, onError) {
    let url = APIConfig.patient.get.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  fetchAccountsOnPatientId(id, onResponse, onError) {
    let url = APIConfig.myPlan.assigned.accountsOnPid.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  fetchActiveAccountsOnPatientId(id, onResponse, onError) {
    let url = APIConfig.myPlan.assigned.activeAccountsOnPid.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  getAccountsByFilter(body, onResponse, onError) {
    let url = APIConfig.myPlan.accountDashboard.getAccountsByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }
  assignAccount(body, onResponse, onError) {
    let url = APIConfig.myPlan.assigned.savePatientAccount;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getPlansForPid(pid, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getPlansForPid.format(pid);
    return this.apiService.get(url, onResponse, onError);
  }
  getPlansForPid2(pid, onResponse, onError) {
    let url = APIConfig.myPlan.assigned.getPlansForPid2.format(pid);
    return this.apiService.get(url, onResponse, onError);
  }
  getAssignedPlansByFilter(body, onResponse, onError) {
    let url = APIConfig.myPlan.assignedPlans.getAssignedPlansByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }
  assignPlansToPid(body, onResponse, onError) {
    let url = APIConfig.myPlan.assigned.assignPlanToPid;
    return this.apiService.post(url, body, onResponse, onError);
  }
  setAccountStatusInactive(body, onResponse, onError) {
    let url = APIConfig.myPlan.assigned.accountInactive;
    return this.apiService.post(url, body, onResponse, onError);
  }
  setPlanStatusInactive(body, onResponse, onError) {
    let url = APIConfig.myPlan.assigned.planInactive;
    return this.apiService.put(url, body, onResponse, onError);
  }
  getWalletAmount(pid, planId, aid, onResponse, onError) {
    let url = APIConfig.myPlan.assigned.walletDetails.format(planId, pid, aid);
    return this.apiService.get(url, onResponse, onError);
  }
  getWalletData(body, onResponse, onError) {
    let url = APIConfig.myPlan.assigned.walletData;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getBlockedAmount(pid, body, onResponse, onError) {
    let url = APIConfig.myPlan.assigned.blockedAmount.format(pid);
    return this.apiService.post(url, body, onResponse, onError);
  }
}

export default AssignUtils;
